import { InfoCircleOutlined } from '@ant-design/icons';
import { Flex, type MenuProps, Tooltip } from 'antd';

import {
  ACQUIRING,
  ATC_BEELINE,
  EMAIL_HANDLER,
  INSTAGRAM,
  INSTAGRAM_LABEL,
  MAX_MESSENGER,
  MAX_MESSENGER_LABEL,
  SMS_SERVICE,
  SMS_SERVICE_LABEL,
  TELEGRAM,
  TELEGRAM_LABEL,
  TELEGRAM_PERSONAL,
  TELEGRAM_PERSONAL_LABEL,
  VK,
  VK_LABEL,
  WAREHOUSE_1C,
  WAREHOUSE_1C_LABEL,
  WHATSAPP,
  YOO_KASSA_LABEL,
} from '@app/constants';
import { SocialIntegrationIcon } from '@app/shared/ui/SocialIntegrationIcon';

import { MAX_INTEGRATION_UNAVAILABLE_MESSAGE } from '@pages/Integrations/IntegrationsList/data/constants';

interface DropdownItemsProps {
  setIsSocialMediaSettingsModalOpen: (status: boolean) => void;
  setCurrentIntegrationType: (integration: string) => void;
  setIsEmailModalOpen: (status: boolean) => void;
  hasRightToAddWhatsAppIntegrations: boolean | undefined;
  setIsAtcModalOpen: (status: boolean) => void;
  setIsOpenAddWhatsAppIntegrationWarningModal: (status: boolean) => void;
  navigateToYooKassaAccessRightPage: () => Promise<void>;
  show1CIntegration: boolean;
  create1CIntegration: () => void;
  isMaxIntegrationBlocked: boolean;
}
export const DropdownItems = ({
  setIsSocialMediaSettingsModalOpen,
  setCurrentIntegrationType,
  setIsEmailModalOpen,
  hasRightToAddWhatsAppIntegrations,
  setIsAtcModalOpen,
  setIsOpenAddWhatsAppIntegrationWarningModal,
  navigateToYooKassaAccessRightPage,
  show1CIntegration,
  create1CIntegration,
  isMaxIntegrationBlocked,
}: DropdownItemsProps): MenuProps['items'] => {
  return [
    ...(hasRightToAddWhatsAppIntegrations
      ? [
          {
            key: '1',
            label: (
              <Flex
                onClick={() => {
                  setIsOpenAddWhatsAppIntegrationWarningModal(true);
                }}
                align="center"
                gap={12}
              >
                <SocialIntegrationIcon type={WHATSAPP} size="md" />
                <span>WhatsApp</span>
              </Flex>
            ),
          },
        ]
      : []),
    {
      key: '2',
      label: (
        <Flex
          onClick={() => {
            setIsEmailModalOpen(true);
          }}
          align="center"
          gap={12}
        >
          <SocialIntegrationIcon type={EMAIL_HANDLER} size="md" />
          <span>Обработка почты</span>
        </Flex>
      ),
    },
    {
      key: '3',
      label: (
        <Flex
          onClick={() => {
            setCurrentIntegrationType(INSTAGRAM);
            setIsSocialMediaSettingsModalOpen(true);
          }}
          align="center"
          gap={12}
        >
          <SocialIntegrationIcon type={INSTAGRAM} size="md" />
          <span>{INSTAGRAM_LABEL}</span>
        </Flex>
      ),
    },
    {
      key: '4',
      label: (
        <Flex
          onClick={() => {
            setCurrentIntegrationType(ATC_BEELINE);
            setIsAtcModalOpen(true);
          }}
          className="beeline-dropdown-item"
          align="center"
          gap={12}
        >
          <SocialIntegrationIcon type={ATC_BEELINE} size="md" />
          <span>Beeline</span>
        </Flex>
      ),
    },
    {
      key: '5',
      label: (
        <Flex
          onClick={() => {
            setCurrentIntegrationType(VK);
            setIsSocialMediaSettingsModalOpen(true);
          }}
          className="vk-dropdown-item"
          align="center"
          gap={12}
        >
          <SocialIntegrationIcon type={VK} size="md" />
          <span>{VK_LABEL}</span>
        </Flex>
      ),
    },
    {
      key: '6',
      label: (
        <Flex
          onClick={() => {
            setCurrentIntegrationType(TELEGRAM);
            setIsSocialMediaSettingsModalOpen(true);
          }}
          className="telegram-dropdown-item"
          align="center"
          gap={12}
        >
          <SocialIntegrationIcon type={TELEGRAM} size="md" />
          <span>{TELEGRAM_LABEL}</span>
        </Flex>
      ),
    },
    {
      key: '8',
      label: (
        <Flex
          onClick={navigateToYooKassaAccessRightPage}
          className="yoo-kassa-dropdown-item"
          align="center"
          gap={12}
        >
          <SocialIntegrationIcon type={ACQUIRING} size="md" />
          <span>{YOO_KASSA_LABEL}</span>
        </Flex>
      ),
    },
    ...(show1CIntegration
      ? [
          {
            key: '9',
            label: (
              <Flex onClick={create1CIntegration} align="center" gap={12}>
                <SocialIntegrationIcon type={WAREHOUSE_1C} size="md" />
                <span>{WAREHOUSE_1C_LABEL}</span>
              </Flex>
            ),
          },
        ]
      : []),
    {
      key: '10',
      label: (
        <Flex
          onClick={() => {
            setCurrentIntegrationType(TELEGRAM_PERSONAL);
            setIsSocialMediaSettingsModalOpen(true);
          }}
          className="telegram-dropdown-item"
          align="center"
          gap={12}
        >
          <SocialIntegrationIcon type={TELEGRAM_PERSONAL} size="md" />
          <span>{TELEGRAM_PERSONAL_LABEL}</span>
        </Flex>
      ),
    },
    {
      key: '11',
      disabled: isMaxIntegrationBlocked,
      label: (
        <Flex
          onClick={() => {
            if (isMaxIntegrationBlocked) {
              return;
            }

            setCurrentIntegrationType(MAX_MESSENGER);
            setIsSocialMediaSettingsModalOpen(true);
          }}
          align="center"
          gap={12}
        >
          <SocialIntegrationIcon type={MAX_MESSENGER} size="md" />
          <span>{MAX_MESSENGER_LABEL}</span>
          {isMaxIntegrationBlocked && (
            <Tooltip title={MAX_INTEGRATION_UNAVAILABLE_MESSAGE}>
              <InfoCircleOutlined
                style={{ pointerEvents: 'auto' }}
                onClick={(event) => event.stopPropagation()}
              />
            </Tooltip>
          )}
        </Flex>
      ),
    },
    {
      key: '12',
      label: (
        <Flex
          onClick={() => {
            setCurrentIntegrationType(SMS_SERVICE);
            setIsSocialMediaSettingsModalOpen(true);
          }}
          align="center"
          gap={12}
        >
          <SocialIntegrationIcon type={SMS_SERVICE} size="md" />
          <span>{SMS_SERVICE_LABEL}</span>
        </Flex>
      ),
    },
  ];
};
